import React from 'react'

import Drawer from '@material-ui/core/Drawer'

import { LabelVal } from 'components/common/others'
import { FormTitle } from 'components/Maintainance/components'

import { get } from 'lodash'

const ViewBranch = ({ open, onClose, anchorObj }) => {
  const statusView = () => {
    if (anchorObj.status === 1) return 'Active'
    else if (anchorObj.status === 2) return 'In Active'
    else return 'N/A'
  }

  return (
    <Drawer anchor='right' open={open} onClose={onClose} style={{ width: '100%' }}>
      <FormTitle title='View Branch' closeFunc={onClose} style={{ width: '100%' }} />
      <div className='table-responsive dashboardtblScroll' id='style-1' style={{ maxHeight: 'calc(100vh - 65px)', height: 'calc(100vh - 65px)', background: '#efefef', width: '450px' }}>
        <div style={{ padding: '10px' }}>
          <div style={{ padding: '16px', background: '#fff', borderRadius: '4px' }}>
            <LabelVal label='Branch Name' value={get(anchorObj, 'companyBranchName', 'N/A')} w={50} inline />
            <LabelVal label='Branch Code' value={get(anchorObj, 'companyBranchCode', 'N/A')} w={50} inline />
            <LabelVal label='Status' value={statusView()} inline />
          </div>
        </div>
      </div>
    </Drawer>
  )
}

export default ViewBranch
